// Configuration EmailJS
// ⚠️ IMPORTANT : Remplacez ces valeurs par vos vraies clés EmailJS

export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_546waya', // ⚠️ Remplacez par votre nouveau Service ID après reconfiguration Gmail
  TEMPLATE_ID: 'template_ph5o0em', // ✅ Votre Template ID est correct
  PUBLIC_KEY: 'XTtJ9Dl5vnxRxnfs9' // ✅ Votre Public Key est correct
};

// 📋 Instructions détaillées pour configurer EmailJS :
// 
// 1. Créez un compte sur https://www.emailjs.com/
// 2. Créez un service email :
//    - Allez dans "Email Services" → "Add New Service"
//    - Choisissez votre fournisseur (Gmail, Outlook, etc.)
//    - Notez le Service ID (ex: service_abc123)
//
// 3. Créez un template d'email :
//    - Allez dans "Email Templates" → "Create New Template"
//    - Utilisez ce contenu :
//      Nom: {{name}}
//      Email: {{email}}
//      Sujet: {{title}}
//      Message: {{message}}
//      Heure: {{time}}
//    - Notez le Template ID (ex: template_xyz789)
//
// 4. Récupérez votre clé publique :
//    - Allez dans "Account" → "API Keys"
//    - Copiez votre Public Key
//
// 5. Remplacez les valeurs ci-dessus par vos vraies clés
//
// 🔍 Les variables du template DOIVENT être exactement :
//    - {{name}} : Nom de l'expéditeur
//    - {{email}} : Email de l'expéditeur  
//    - {{title}} : Sujet du message (pas 'subject')
//    - {{message}} : Contenu du message
//    - {{time}} : Heure d'envoi (ajoutée automatiquement)
//
// 🚨 ERREUR ACTUELLE : Problème d'authentification Gmail !
// ✅ Public Key et Template ID sont corrects
// ❌ Service ID doit être mis à jour après reconfiguration Gmail
// 
// Solution : Reconfigurez votre service Gmail dans EmailJS
// 1. Supprimez le service Gmail actuel (Email Services → Delete)
// 2. Recréez-le (Add New Service → Gmail)
// 3. Acceptez TOUTES les permissions demandées
// 4. Copiez le nouveau Service ID et remplacez 'service_546waya' 